export enum RequestOrderType {
  TP,
  SL_BID,
  CALL,
  BMARK,
  SL_ASK,
  SL_ATRATE,
  TSL,
  TSL_BID,
  TSL_ASK,
  ALGO,
  MARKET,
  BMALGO,
}

export namespace RequestOrderType {
  let elements = [
    RequestOrderType.TP,
    RequestOrderType.SL_BID,
    RequestOrderType.CALL,
    RequestOrderType.BMARK,
    RequestOrderType.SL_ASK,
    RequestOrderType.SL_ATRATE,
    RequestOrderType.TSL,
    RequestOrderType.TSL_BID,
    RequestOrderType.TSL_ASK,
    RequestOrderType.ALGO,
    RequestOrderType.MARKET,
    RequestOrderType.BMALGO,
  ];
  let alias = "com.bcdfx.model.RequestOrderType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
